import { render, staticRenderFns } from "./zxItem.vue?vue&type=template&id=6f9a2299&scoped=true"
import script from "./zxItem.vue?vue&type=script&lang=js"
export * from "./zxItem.vue?vue&type=script&lang=js"
import style0 from "./zxItem.vue?vue&type=style&index=0&id=6f9a2299&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a2299",
  null
  
)

export default component.exports